module.exports = __webpack_public_path__ + "media/images/flags/en-a7cfcb005eb61e3fd2d8915d59fa65f6.svg";